function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "no_mic"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m15 20h-6c-.553 0-1 .447-1 1s.447 1 1 1h6c.553 0 1-.447 1-1s-.447-1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.722 13.9c.067.014.134.02.199.02.466 0 .884-.327.979-.802.068-.333.1-.698.1-1.118 0-.553-.447-1-1-1s-1 .447-1 1c0 .285-.02.521-.061.722-.109.542.242 1.069.783 1.178z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m8.928 5.299c.475.281 1.087.129 1.371-.346.356-.597.992-.953 1.701-.953 1.103 0 2 .897 2 2v4c0 .553.447 1 1 1s1-.447 1-1v-4c0-2.206-1.794-4-4-4-1.42 0-2.697.721-3.418 1.928-.283.474-.129 1.088.346 1.371z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.707 20.293-18-18c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l5.707 5.707v2.586c0 2.206 1.794 4 4 4 .724 0 1.412-.206 2.021-.565l.737.737c-.808.538-1.758.828-2.758.828-2.757 0-5-2.243-5-5 0-.553-.447-1-1-1s-1 .447-1 1c0 3.859 3.141 7 7 7 1.537 0 2.988-.496 4.187-1.399l4.106 4.106c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414zm-9.707-6.293c-1.103 0-2-.897-2-2v-.586l2.512 2.512c-.166.044-.336.074-.512.074z"
})));

var Svg076Microphone = function Svg076Microphone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg076Microphone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/076-microphone.fbbcc087.svg";
export { ForwardRef as ReactComponent };